var map = {
	"./bg-project.jpg": 9328,
	"./bg-project2.jpg": 712,
	"./bg-project3.jpg": 7973,
	"./chrome-extension.png": 2443,
	"./grocery-list-app.png": 8177,
	"./youtube-clone.png": 8810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9289;